
const labelsDefault = {
    name: {label: "name", required: true},
    panel: {label: "panel_name", required: true},
    assets: {label: "assets_count", required: true}
}

export default labelsDefault